import {useCallback, useState} from "react";
import {POST} from "../../../Hooks/RequestV2";
import {isCartQuantityLimitError} from "../QuantityLimit/quantityLimit";
import {AddProductToCartPayload, AddProductToCartResult} from "./types";

export function useAddProductToCart(): {
    addProductToCart: (payload: AddProductToCartPayload) => Promise<AddProductToCartResult>;
    httpStatusCode: number;
    isSuccess: boolean;
    response: unknown;
} {
    const [httpStatusCode, setHttpStatusCode] = useState(0);
    const [response, setResponse] = useState<unknown>(null);
    const isSuccess = httpStatusCode >= 200 && httpStatusCode < 300;

    const addProductToCart = useCallback((payload: AddProductToCartPayload): Promise<AddProductToCartResult> => {
        setHttpStatusCode(0);
        setResponse(null);

        return POST('/user/cart/add', payload)
            .then(async (result): Promise<AddProductToCartResult> => {
                setHttpStatusCode(result.status);

                if (!result.ok){
                    if (result.status === 422) {
                        const errorPayload = await result.json().catch(() => null);

                        return {isSuccess: false, quantityLimitExceeded: isCartQuantityLimitError(errorPayload)};
                    }

                    return {isSuccess: false, quantityLimitExceeded: false};
                }

                const text = await result.text();

                setResponse(text === '' ? {} : JSON.parse(text));

                const broadcastChannel = new BroadcastChannel('reload-cart');

                broadcastChannel.postMessage('reload');

                return {isSuccess: true, quantityLimitExceeded: false};
            });
    }, []);

    return {response, httpStatusCode, isSuccess, addProductToCart};
}
